import React from "react";
import { useBackgrounds } from "../contexts/BackgroundsContext";

// Renders the configurable background layer for a section.
// lightText=true  -> section has light text (apply dark overlay on images)
// lightText=false -> section has dark text (apply light overlay on images)
export default function SectionBg({ section, lightText = false }) {
  const { get } = useBackgrounds();
  const cfg = get(section);
  if (!cfg) return null;

  if (cfg.type === "color") {
    return <div className="absolute inset-0 z-0" style={{ backgroundColor: cfg.value }} />;
  }

  // image
  return (
    <div className="absolute inset-0 z-0">
      <img src={cfg.value} alt="" className="w-full h-full object-cover" />
      {lightText ? (
        <>
          <div className="absolute inset-0 bg-gradient-to-b from-[#1C1815]/85 via-[#1C1815]/60 to-[#1C1815]/85" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1C1815]/60 to-transparent" />
        </>
      ) : (
        <div className="absolute inset-0 bg-[#FBF7F0]/88" />
      )}
    </div>
  );
}
